import React, { useContext } from "react";
import handWithPhone from "../../../assets/images/home-page/handWithPhone.webp";
import {
  StyledAboutProjectHomePageBlock,
  StyledAboutProjectHomePageSection,
  StyledAboutProjectInfo,
  StyledBringAllTheContactBlock,
  StyledBringAllTheContactContent,
  StyledBringInfo,
  StyledTypeChatIcon
} from "./styledHomePageAboutProject";
import { StyledDecorationElementHomePage, StyledMainTitleHomePage } from "../styledHomePage";
import { StyledButton } from "../../styles/styledButton";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { NavLink, useHistory } from "react-router-dom";
import BringGlobal from "../../../assets/images/home-page/bring-block/bring-global.svg";
import BringViber from "../../../assets/images/home-page/bring-block/bring-viber.svg";
import BringTelegram from "../../../assets/images/home-page/bring-block/bring-telegram.svg";
import { AuthContext } from "../../../App";
import { closableNotification } from "../../notification/ClosableNotification";
import Tooltip from "rc-tooltip";
import { motion } from "framer-motion";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const HomePageAboutProject = () => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const handleRedirect = (e) => {
    if (user) {
      e.preventDefault();
      return closableNotification("You have already registration", "success");
    }
    history.push("/registration");
  };

  const textAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: custom => ({
      x: 0,
      opacity: 1,
      transition: { delay: custom * 0.2 }
    })
  };

  const MotionNavLink = motion(NavLink);

  return (
    <StyledAboutProjectHomePageSection
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <StyledAboutProjectHomePageBlock>
        <StyledAboutProjectInfo
          custom={1}
          variants={HookResponsive() ? textAnimation : null}
        >
          <div>
            <StyledMainTitleHomePage
              as="h1"
              className="main-title"
              size="60"
              lineHeight="60"
              weight="700"
            >
              Text me is your best multi-channel online consultant on the site.
            </StyledMainTitleHomePage>
            <StyledDecorationElementHomePage
              className="main-description"
              as="p"
              display="block"
              maxWidth="570"
              color="#333333"
              weight="300"
              size="24"
              lineHeight="29"
              mt="20"
              mb="30"
            >
              Do you need live chat on a site that can optimize conversions? Then Text me was designed just for your
              business!
            </StyledDecorationElementHomePage>
            <StyledButton
              border
              size="30"
              onClick={handleRedirect}
            >
              <StyledDecorationElementHomePage
                className="lets-try-btn"
                size="18"
                weight="500"
                color="#FFFFFF"
              >Try for free</StyledDecorationElementHomePage>
              <StyledDecorationElementHomePage
                className="sing-up-btn"
                size="20"
              >Try for free</StyledDecorationElementHomePage>
            </StyledButton>
          </div>
          <LazyLoadImage
            src={handWithPhone}
            alt=""
            visibleByDefault={true}
            width={500}
            height={535}
          />
        </StyledAboutProjectInfo>
      </StyledAboutProjectHomePageBlock>
      <StyledBringAllTheContactBlock>
        <StyledBringAllTheContactContent>
          <StyledBringInfo>
            <StyledTypeChatIcon>
              <Tooltip
                placement="top"
                overlay="Manual connect telegram"
              >
                <MotionNavLink
                  custom={4}
                  whileHover={{ y: -20 }}
                  transition={{ type: "spring", stiffness: 300, damping: 10 }}
                  to="/manual-connect-telegram"
                  className="circle telegram"
                >
                  <LazyLoadImage
                    src={BringTelegram}
                    alt="bring telegram"
                  />
                </MotionNavLink>
              </Tooltip>
              <Tooltip
                placement="top"
                overlay="Manual connect viber"
              >
                <MotionNavLink
                  whileHover={{ y: -20 }}
                  transition={{ type: "spring", stiffness: 300, damping: 10 }}
                  to="/manual-connect-viber"
                  className="circle viber"
                >
                  <LazyLoadImage
                    src={BringViber}
                    alt="bring viber"
                  />
                </MotionNavLink>
              </Tooltip>
              <Tooltip
                placement="top"
                overlay="Manual connect web"
              >
                <MotionNavLink
                  whileHover={{ y: -20 }}
                  transition={{ type: "spring", stiffness: 300, damping: 10 }}
                  to="/manual-connect-web"
                  className="circle global"
                >
                  <LazyLoadImage
                    src={BringGlobal}
                    alt="bring global"
                  />
                </MotionNavLink>
              </Tooltip>
            </StyledTypeChatIcon>
            <div>
              <StyledMainTitleHomePage
                as="h5"
                size="20"
                lineHeight="30"
                weight="600"
              >
                Bring all the contact channels to one location:
              </StyledMainTitleHomePage>
              <StyledTypeChatIcon className="response-icon">
                <Tooltip
                  placement="top"
                  overlay="Manual connect telegram"
                >
                  <NavLink
                    to="/manual-connect-telegram"
                    className="circle telegram"
                  >
                    <LazyLoadImage
                      src={BringTelegram}
                      alt="bring telegram"
                    />
                  </NavLink>
                </Tooltip>
                <Tooltip
                  placement="top"
                  overlay="Manual connect viber"
                >
                  <NavLink
                    to="/manual-connect-viber"
                    className="circle viber"
                  >
                    <LazyLoadImage
                      src={BringViber}
                      alt="bring viber"
                    />
                  </NavLink>
                </Tooltip>
                <Tooltip
                  placement="top"
                  overlay="Manual connect web"
                >
                  <NavLink
                    to="/manual-connect-web"
                    className="circle global"
                  >
                    <LazyLoadImage
                      src={BringGlobal}
                      alt="bring global"
                    />
                  </NavLink>
                </Tooltip>
              </StyledTypeChatIcon>
              <StyledDecorationElementHomePage
                size="20"
                weight="300"
                display="block"
                mt="10"
                color="#646464"
                className="bring-info-text"
              >
                live chat, social media, messengers and phone calls.
                Engage with clients using their preferred channel
              </StyledDecorationElementHomePage>
            </div>

          </StyledBringInfo>
          <div>
            <StyledButton
              as={NavLink}
              className="action-btn-manual"
              to="/manual-connect-web?currentTab=aboutProduct"
              border
            >
              <StyledDecorationElementHomePage
                size="25"
                className="icon-chevron-right"
              />
              <StyledDecorationElementHomePage
                color="#FFFFFF"
                size="18"
              >Connect!</StyledDecorationElementHomePage>
            </StyledButton>
          </div>
        </StyledBringAllTheContactContent>
      </StyledBringAllTheContactBlock>
    </StyledAboutProjectHomePageSection>
  );

};
export default HomePageAboutProject;